import { ENDPOINTS } from '../consts/endpoints';
import { AbstractApi } from '../../abstract-api';
import { FaqApiResponse } from '../types/faq.types';

export class GraphQLApi extends AbstractApi {
  async getFaq(graphQlQuery: string): Promise<FaqApiResponse> {
    const axios = await this.axios();
    const { data } = await axios.post<FaqApiResponse>(ENDPOINTS.CONTENT.BASE, {
      query: graphQlQuery,
    });
    return data;
  }
}
